import { TransactionStateInterface } from './interfaces';

export const currentTransactionInitialState: TransactionStateInterface = {
  currentTransactionValue: 0,
};
